import { cva } from 'class-variance-authority';

const selectOptionBaseStyles = [
  'p-3',
  'cursor-pointer',
  'flex',
  'items-center',
];

const selectOptionStylesSAG = cva([
  ...selectOptionBaseStyles,
  'hover:bg-[#62EEC7]',
  'dark:hover:bg-[#005159]',
]);

const selectOptionSelectedStylesSAG = cva([
  ...selectOptionBaseStyles,
  'bg-[#62EEC7]',
  'dark:bg-[#005159]',
]);

const selectionOptionTextStylesSAG = cva(['text-[#000028]', 'dark:text-white']);

const selectOptionStylesSHS = cva([
  ...selectOptionBaseStyles,
  'hover:bg-[#f2f2f2]',
  'dark:hover:bg-[#474747]',
]);

const selectOptionSelectedStylesSHS = cva([
  ...selectOptionBaseStyles,
  'bg-[#e6e6e6]',
  'dark:bg-[#666]',
]);

const selectionOptionTextStylesSHS = cva(['dark:text-[#e6e6e6]']);

export {
  selectOptionStylesSAG,
  selectOptionStylesSHS,
  selectionOptionTextStylesSAG,
  selectionOptionTextStylesSHS,
  selectOptionSelectedStylesSAG,
  selectOptionSelectedStylesSHS,
};
